import type { ITypedReduxAction } from '../../types/redux/actionType';
import type { IAiSummaryResponse } from '../../types/newbuildingsSummary';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EGetNewbuildingsSummaryActionTypes {
  Loading = 'GET_NEWBUILDINGS_SUMMARY/LOADING',
  Succeed = 'GET_NEWBUILDINGS_SUMMARY/SUCCEED',
  Failed = 'GET_NEWBUILDINGS_SUMMARY/FAILED',
}

export type TGetNewbuildingsSummaryLoading = ITypedReduxAction<EGetNewbuildingsSummaryActionTypes.Loading, void>;
export type TGetNewbuildingsSummarySucceed = ITypedReduxAction<
  EGetNewbuildingsSummaryActionTypes.Succeed,
  IAiSummaryResponse
>;
export type TGetNewbuildingsSummaryFailed = ITypedReduxAction<EGetNewbuildingsSummaryActionTypes.Failed, void>;

export type TGetNewbuildingsSummaryActions =
  | TGetNewbuildingsSummaryLoading
  | TGetNewbuildingsSummarySucceed
  | TGetNewbuildingsSummaryFailed;

export const getNewbuildingsSummaryLoading = actionGenerator<EGetNewbuildingsSummaryActionTypes.Loading>(
  EGetNewbuildingsSummaryActionTypes.Loading,
);
export const getNewbuildingsSummarySucceed = actionGenerator<
  EGetNewbuildingsSummaryActionTypes.Succeed,
  IAiSummaryResponse
>(EGetNewbuildingsSummaryActionTypes.Succeed);
export const getNewbuildingsSummaryFailed = actionGenerator<EGetNewbuildingsSummaryActionTypes.Failed>(
  EGetNewbuildingsSummaryActionTypes.Failed,
);
